import React from 'react'
import Skeleton from 'react-loading-skeleton'

const ProductPurchaseActionsSkeleton = () => {
  return (
    <div className="border border-[#ededed] rounded-2xl">
      {/* Stock status header skeleton - matches new design */}
      <div className="rounded-t-2xl py-3 flex items-center justify-center gap-3 font-bold text-[15px] border-b border-[#ededed] bg-gray-50">
        <Skeleton
          width={20}
          height={20}
          baseColor="#f1f5f9"
          highlightColor="#e2e8f0"
          className="!rounded-sm"
        />
        <Skeleton
          width={120}
          height={18}
          baseColor="#f1f5f9"
          highlightColor="#e2e8f0"
          className="!rounded-sm"
        />
      </div>

      {/* Payment methods section skeleton */}
      <div className="p-4 border-b border-[#ededed]">
        <Skeleton
          width={150}
          height={18}
          baseColor="#f1f5f9"
          highlightColor="#e2e8f0"
          className="mb-3 !rounded-sm"
        />
        <div className="flex flex-col gap-2 w-full">
          {Array(4)
            .fill()
            .map((_, index) => (
              <Skeleton
                key={index}
                width={350}
                height={32}
                baseColor="#f8fafc"
                highlightColor="#e2e8f0"
                className="!rounded-lg"
              />
            ))}
        </div>
      </div>

      {/* Purchase actions section */}
      <div className="p-4">
        {/* Quantity selector skeleton */}
        <div className="mb-6">
          <Skeleton
            width={100}
            height={18}
            baseColor="#f1f5f9"
            highlightColor="#e2e8f0"
            className="mb-3 !rounded-sm"
          />
          <div className="flex items-center gap-3">
            <Skeleton
              width={120}
              height={40}
              baseColor="#f8fafc"
              highlightColor="#e2e8f0"
              className="!rounded-lg"
            />
          </div>
        </div>

        {/* Action buttons skeleton */}
        <div className="space-y-3">
          <Skeleton
            height={64}
            baseColor="#f8fafc"
            highlightColor="#e2e8f0"
            className="!rounded-xl"
          />
          <div className="flex gap-3">
            <Skeleton
              width={60}
              height={48}
              baseColor="#f8fafc"
              highlightColor="#e2e8f0"
              className="!rounded-xl"
            />
            <Skeleton
              width={60}
              height={48}
              baseColor="#f8fafc"
              highlightColor="#e2e8f0"
              className="!rounded-xl"
            />
            <Skeleton
              width={200}
              height={48}
              baseColor="#f8fafc"
              highlightColor="#e2e8f0"
              className="!rounded-xl flex-1 w-full"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductPurchaseActionsSkeleton
